import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
// Modern gradient card for highlights and CTAs
const GradientCard = React.forwardRef(({ className, children, gradient = 'blue', ...props }, ref) => {
    const gradientClasses = {
        blue: 'bg-gradient-to-br from-blue-500 to-blue-700',
        purple: 'bg-gradient-to-br from-purple-500 to-purple-700',
        green: 'bg-gradient-to-br from-green-500 to-green-700',
        orange: 'bg-gradient-to-br from-orange-500 to-orange-700',
        pink: 'bg-gradient-to-br from-pink-500 to-pink-700'
    };
    return (_jsx("div", { ref: ref, className: cn('text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-200', gradientClasses[gradient], className), ...props, children: children }));
});
GradientCard.displayName = 'GradientCard';
const GradientCardHeader = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('px-6 py-5', className), ...props })));
GradientCardHeader.displayName = 'GradientCardHeader';
const GradientCardTitle = React.forwardRef(({ className, ...props }, ref) => (_jsx("h3", { ref: ref, className: cn('text-xl font-bold text-white', className), ...props })));
GradientCardTitle.displayName = 'GradientCardTitle';
const GradientCardContent = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('px-6 pb-6', className), ...props })));
GradientCardContent.displayName = 'GradientCardContent';
export { GradientCard, GradientCardHeader, GradientCardTitle, GradientCardContent };
